import * as React from "react";
import { BASELINE_VIEW, WORKSPACE_VIEW } from "../../../changesConstants";
import { IntlContext, IntlContextProvider } from "../../../../core/core-widgets/contexts/IntlContext";

interface ViewTypeSelectorProps {
    hidden: boolean;
    viewType: string;
    displayLoading: boolean;
}

interface ViewTypeSelectorDispatchProps {
    handleViewTypeChanged: (view: string) => void;
}

export const ViewTypeSelector = (props: ViewTypeSelectorProps & ViewTypeSelectorDispatchProps) => {
    const { handleViewTypeChanged, viewType, displayLoading, hidden } = props;
    if (hidden) {
        return null;
    }
    return (
        <IntlContextProvider>
            <IntlContext.Consumer>
                {({ intl }) => {
                    return (
                        <>
                            <div>{intl.formatMessage({ id: "workspaceChanges.viewSelector.display" })}</div>
                            <div>
                                <select
                                    id={"viewSelector"}
                                    onChange={(event) => handleViewTypeChanged(event.target.value)}
                                    value={viewType}
                                    disabled={displayLoading}
                                >
                                    <option value={BASELINE_VIEW}>
                                        {intl.formatMessage({ id: "workspaceChanges.viewSelector.baseline" })}
                                    </option>
                                    <option value={WORKSPACE_VIEW}>
                                        {intl.formatMessage({ id: "workspaceChanges.viewSelector.workspace" })}
                                    </option>
                                </select>
                            </div>
                        </>
                    );
                }}
            </IntlContext.Consumer>
        </IntlContextProvider>
    );
};
